import { client } from '@/services/api/axios.ts';
import toast from 'react-hot-toast';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useSession } from '@/services/providers/use-session.ts';

export const useUnsubscribeNotificationRule = ({
  onSuccess,
  onError,
}: {
  onSuccess?: () => void;
  onError?: () => void;
} = {}) => {
  const { userId } = useSession();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ ruleId }: { ruleId: string }) => {
      return toast.promise(
        client.delete(`/notifications/rules/${ruleId}/assignments/${userId}`),
        {
          loading: 'Unsubscribing from rule...',
          success: 'Successfully unsubscribed from the rule.',
          error: 'Failed to unsubscribe from the rule.',
        }
      );
    },
    onSuccess: () => {
      onSuccess?.();
    },
    onError: () => {
      onError?.();
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ['notifications', 'rules'] });
    },
  });
};
